import axios from 'axios';
import { dashedDate } from '@/js/utils/dateTimeUtils';
import { getFluxApiUrl } from '@utils/utils';
import type { MergedOfferItemData } from '@interfaces/offer';
import type { HotelCatalogueType } from '@interfaces/hotel-catalogue-types';
import type { TourOperator } from '@interfaces/common';

export const getCatalogInfo = async (
	offerData: MergedOfferItemData,
	hotelData: { Hotel: { IffCode: string } },
	operator: TourOperator,
	operatorCodeMatching = true,
	code?: string
): Promise<HotelCatalogueType | null> => {
	try {
		const fluxApiUrl = getFluxApiUrl();
		const hotelId = hotelData.Hotel.IffCode;
		const startDate = dashedDate(offerData.StartDate);
		const offerCode = offerData.OfferCode;

		const catalogUrl = `${fluxApiUrl}/v1/giata-catalog?HotelIffCode=${hotelId}&StartDate=${startDate}`;

		const baseUrl = operatorCodeMatching ? `${catalogUrl}&OfferCode=${offerCode}` : catalogUrl;

		const operatorCode = code || operator.Code;
		const url = `${baseUrl}&TourOperatorCode=${operatorCode}`;

		const response = await axios.get(url);
		return response.data;
	} catch (error) {
		console.error('Error fetching catalog information:', error);
		return null;
	}
};

export default {
	getCatalogInfo,
};
